<template>
  <div>
    <img
        class="back"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back2.png')"
      />
    <van-popup v-model="showMood" @close="close()" round>
      <div class="pop1">
        <img class="pop-img2" v-lazy="succImg" />
        <div class="popFt1">
          <van-button type="warning" @click="showMood = false" class="popbtn1"
            >我也来领5折优惠券</van-button
          >
        </div>
        <div style="text-align: center">
          <img @click="showMood = false" class="closeImg" v-lazy="closeImg" />
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="show"
      @close="close()"
      round
      style="border-radius: 0; border: none"
    >
      <div class="mainContent">
        <img class="findImg" v-lazy="findImg" />
        <div class="title">如何分享</div>
        <div class="des">
          <div><span class="sp">1</span>点击右上角“…”</div>
        </div>
        <div class="des">
          <div>
            <span class="sp">2</span>点击【发送给朋友】或【分享到朋友圈】即可
          </div>
        </div>
        <div class="des">
          <div><span class="sp">3</span>3位好友助力，即可解锁测评5折优惠券</div>
        </div>
        <van-button @click="close()" class="popbtn">我知道了</van-button>
      </div>
    </van-popup>
    <div class="note">
      <div class="back">
        <div class="pop1">
          <img class="pop-img1" v-lazy="resBgImg" />

          <div class="more">
            <div class="name">
              还需<span style="color: #f5a623; font-size: 18px">{{
                number
              }}</span
              >位好友助力
            </div>
            <div class="helpman">
              <img class="img1" v-lazy="res1" />
              <img class="img1" v-lazy="res2" />
              <img class="img1" v-lazy="res3" />
            </div>
          </div>

          <van-button v-show="finished" @click="go()" class="popbtn"
            >使用我的优惠券</van-button
          >
          <van-button v-show="!finished" @click="showP()" class="popbtn"
            >邀请好友助力领取</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sdk from "../../../mixin/share";
import { getHelp, helpCreat, zhuli } from "@/http/api";
export default {
  name: "help",
  data() {
    return {
      showMood: false,
      show: false,
      number: 3,
      closeImg: require("./../../../assets/img/test/close.png"),
      succImg: require("./../../../assets/img/test/helpS.png"),
      resBgImg: require("./../../../assets/img/test/help.png"),
      res1: require("./../../../assets/img/test/helpman.png"),
      res2: require("./../../../assets/img/test/helpman.png"),
      res3: require("./../../../assets/img/test/helpman.png"),
      findImg: require("./../../../assets/img/test/find.png"),
      code: "",
      isCode: "",
      finished: false,
    };
  },
  created() {
    this.isCode = this.$route.path.split("help/")[1] || "";
    // console.log(res)
    if (this.isCode) {
      zhuli({
        active_id: this.isCode,
      }).then((res) => {
        console.log(res);
        if (res.code == "SUCCESS") {
          this.showMood = true;
        }
      });
    }
    getHelp().then((res) => {
      res.data.objects[0].helpers_info.forEach((item, index) => {
        if (index === 0) {
          this.res1 = item.avatar;
        } else if (index === 1) {
          this.res2 = item.avatar;
        } else {
          this.res3 = item.avatar;
        }
      });
      if (res.data.objects[0].helpers_info.length >= 3) {
        this.number = 0;
        this.finished = true;
      } else {
        this.number = 3 - res.data.objects[0].helpers_info.length;
      }
    });
    // this.code = this.$route.path.split('sendDetail/')[1] || '';
    // let eval_id = localStorage.testId || ''
    let date = new Date();
    let day =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    helpCreat({
      date: day,
    }).then((res) => {
      this.code = res.data.id;
      this.localUrl = window.location.href.split("#")[0];
      const dataForWeixin = {
        title: `这个心理测评很不错！`, // 分享标题
        desc: "帮我助力领5折优惠券吧...", // 分享内容
        linkurl: `${this.localUrl}#/my/help/${this.code}`, // 分享链接
        img: require("./../../../assets/img/logo.png"), // 分享内容显示的图片(图片必须是正方形的链接)
      };
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        sdk.getJSSDK(dataForWeixin);
      }
      // this.code = ''
    });
  },
  methods: {
    goHome() {
      this.$router.push("/my/center");
    },
    // 跳转到测评详情
    showP() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    go() {
      if (this.isCode) {
        this.$router.push("./../coupon");
      } else {
        this.$router.push("./coupon");
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 5px;
  top: 5px;
}
.note {
  background: linear-gradient(154deg, #ffb082 0%, #fe3e28 100%);
  // height: 100vh;
  padding-top: 40px;
  padding-bottom: 48px;
}

.mainContent {
  height: 100vh;
  width: 100vw;
  font-size: 20px;
  padding-top: 89px;
  padding-left: 23px;
  padding-right: 23px;
  background-color: rgba(255, 255, 255, 0.95);

  .findImg {
    position: absolute;
    right: 50px;
    top: 20px;
    width: 50vw;
  }

  .sp {
    display: inline-block;
    width: 19px;
    height: 19px;
    line-height: 19px;
    font-size: 16px;
    background: #f5a623;
    color: #fff;
    text-align: center;
    margin-right: 4px;
  }

  .title {
    font-size: 15px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #4a4a4a;
    line-height: 23px;
    margin-bottom: 15px;
  }

  .des {
    font-size: 15px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #4a4a4a;
    line-height: 23px;
    margin-top: 15px;
  }

  .popbtn {
    width: calc(0.9 * 100vw);
    margin-top: calc(0.47 * 100vw);
    background: #f5a623;
    border-radius: 18px;
    color: #fff;
  }
}

.pop1 {
  margin-top: -17px;
  border-radius: 24px;
  text-align: center;
  position: relative;

  .tt {
    margin-top: 30px;
    width: 90%;
    margin-left: 5%;
  }

  .more {
    position: absolute;
    width: calc(0.54 * 100vw);
    top: calc(0.88 * 100vw);
    left: calc(0.23 * 100vw);
    text-align: center;

    .name {
      font-size: 13px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #4a4a4a;
    }

    .helpman {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;

      img {
        width: calc(0.13 * 100vw);
        height: calc(0.13 * 100vw);
      }
    }
  }

  .pop-img1 {
    width: 93vw;
    // border-radius: 0.5rem;
  }

  .pop-img2 {
    width: 81.8vw;
    // border-radius: 0.5rem;
  }

  .popbtn {
    background: linear-gradient(154deg, #ffc4a1 0%, #fe3e28 100%);
    width: calc(0.581 * 100vw) !important;
    height: calc(0.112 * 100vw);
    border: none;
    position: absolute;
    top: calc(1.38 * 100vw);
    left: calc(0.21 * 100vw);
  }

  .pop-title {
    text-align: center;
    font-size: 0.72rem;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #4a4a4a;
    // line-height: 1.09rem;
    margin-top: -30px;
    padding-top: 40px;
    padding-bottom: 0.14rem;
    background: #fff;
  }

  .pop-exc {
    text-align: center;
    font-size: 0.31rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #4a4a4a;
    // line-height: 0.41rem;
    letter-spacing: 1px;
    padding-bottom: 14px;
    background: #fff;
  }

  .pop-imglist {
    text-align: center;
    margin-bottom: 0.25rem;
    padding-bottom: 44px;

    img {
      height: 0.92rem;
      width: 0.87rem;
    }
  }

  .closeImg {
    height: 30px;
    width: 30px;
    margin: 0 auto;
  }

  .popFt1 {
    text-align: center;
    margin-top: -34px;

    margin-bottom: 20px;

    .popbtn1 {
      width: 80%;
      background-color: #f5a623;
      font-weight: bold;
      color: white;
      border-radius: 0.5rem;
      border: none;
    }

    .getCoupon {
      background-color: #42686e;
    }

    .rightIcon {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-color: green;
      border-radius: 10px;
      color: white;
      margin-left: 10px;
    }
  }

  .popbtn {
    width: 80%;
    // margin-left: 10%;
    // font-weight: bold;
    font-size: 18px;
    color: white;
    border-radius: 0.5rem;
  }

  img {
    width: 8.8rem;
    border-radius: 0.5rem;
  }

  .rightIcon {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 10px;
    color: white;
    position: absolute;
    top: 50%;
    right: 23px;
    transform: translateY(-50%);
    line-height: 20px;
  }
}
</style>
